export default {"src":"/_next/static/media/logo-header-preta-hor.4df7006c.svg","height":248,"width":844,"blurWidth":0,"blurHeight":0};